import 'core-js/proposals/relative-indexing-method'
import 'core-js/features/array/at';
import 'core-js/proposals/math-sum';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import $ from 'jquery';
import jsZip from 'jszip'

// window.$ = window.jQuery = $;
// window.global ||= window;

import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import 'react-toastify/dist/ReactToastify.css';

import './assets/css/fontawesome/css/all.min.css'
import './assets/css/ionicons/css/ionicons.min.css'

import './assets/css/apple/style-responsive.min.css'
import './assets/css/apple/theme/default.css'
import './assets/css/style.min.css'
import './assets/css/app.css'
import './assets/css/animate.min.css'
import './assets/css/bootstrap-social.css'

import 'datatables.net-bs4';
import 'datatables.net-buttons';

import 'datatables.net-buttons-bs4';
import 'datatables.net-buttons/js/buttons.html5.min.js';
import 'datatables.net-buttons/js/buttons.print.min.js';
import 'datatables.net-buttons/js/buttons.colVis.min.js';
import 'datatables.net-fixedcolumns-bs4';

import 'datatables.net-bs/css/dataTables.bootstrap.min.css';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import 'datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css';
import 'datatables.net-fixedcolumns-bs4/css/fixedColumns.bootstrap4.min.css';

import './app/aws/amplify'

import 'react-loading-skeleton/dist/skeleton.css'

import './assets/js/affix'
// import './assets/js/apps'


import ErrorBoundary from './app/components/Layout/ErrorBoundary';
import App from './App';

import { store } from './app/store';
import { sessionDataRedirect, initAuthData, darkModeCheck } from './features/session/sessionSlice';
import { publishLog } from './app/utils/Logs';

// DataTableCore(window, $);
// DataTableBs4(window, $);

window.JSZip = jsZip;

window.addEventListener('unhandledrejection', async function (e) {
  let token = localStorage.getItem("token")

  const state = await store.getState()

  console.error(e)

  if(import.meta.env.MODE === "production"){
    await publishLog(token, {
      message: e.reason?.message,
      url: window.location.href,
      stack: e.reason?.stack?.toString(),
      siteAccessed: state?.site?.model?.sites?.length > 0 && 
        state?.site?.model?.siteActiveIdx && state?.site?.model?.sites[state?.site?.model?.siteActiveIdx] ? 
          state?.site?.model?.sites[state?.site?.model?.siteActiveIdx] : {},
      type: "ERROR"
    })
  }

  return false
})

store.dispatch(darkModeCheck())

store.dispatch(sessionDataRedirect(sessionStorage.getItem("redirect") ?? null))
store.dispatch(initAuthData(true))


ReactDOM.render(
  // <React.StrictMode>
    <Provider store={store}>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </Provider>
  // </React.StrictMode>
  ,document.getElementById('page-container')
);